export default "__VITE_ASSET__BaMIYW7x__"